import React, { Component } from 'react';
import { Container } from './style';
import { webviewRedirect,isJdapp,MpingClick,getBusinessTypeByMP } from '../../../utils/tool';

const ZhiBoStatusObj={
  "0":{
    statusTxt:'预告',
    statusIcon:'yugao',
    btnTxt:'设置提醒'
  },
  "1":{
    statusTxt:'直播中',
    statusIcon:'zhibozhong',
    btnTxt:'进入直播间'
  },
  "3":{
    statusTxt:'回放',
    statusIcon:'huifang',
    btnTxt:'查看回放'
  },
}

const isInJd = isJdapp(); // 是否在京东app中
class ZhiboFloor extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  //去直播间
  gotoLive=(openApp,liveId)=>{
    let h5Url = ''
    if(liveId){
      h5Url = `https://lives.jd.com/#/${liveId}?origin=14&appid=jdzb`
    }
    if(isInJd){
      let url = openApp || h5Url
      if(url){
        window.location.href = url
      }
    }else{
      if(h5Url){
        window.location.href = h5Url
      }
    }
  }

  handleClick=(liveInfo)=>{
    MpingClick("Auction_LiveFloorClick",JSON.stringify({business_type:getBusinessTypeByMP()}))
    const {openApp,liveId} = liveInfo
    this.gotoLive(openApp,liveId)
  }

  timeFormat=(time) => {
    if (!time) {
        return '';
    }
    var date = new Date(time);
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日 ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return M + D + h + m;
  }

  render() {
    const {liveInfo} = this.props
    const {productList,squareIndexImage,title,status,publishTime} = liveInfo
    return (
      <Container>
        <div className="zhibo-floor">
          <div className="left-part">
            <img className="zhibo-img" src={squareIndexImage} />
            {status>=0 &&
              <div className={`zhibo-flag ${ZhiBoStatusObj[status.toString()].statusIcon}`}>
                <div className="zhibo-txt">
                  <div className="zhibo-flag-icon"></div>
                  <div className="zhibo-flag-txt">{ZhiBoStatusObj[status.toString()].statusTxt}</div>
                </div>
                {status==0 && publishTime>0 && <div className="yugao-time">{this.timeFormat(publishTime)}</div>}
            </div>
            
            }
          </div>
          <div className="right-part">
            <div className="zhibo-title">{title}</div>
            <div className="pro-imgs">
              {
                productList && productList.length>0 && productList.map((val,index)=>{
                  return (
                    <img key={index} src={`//img10.360buyimg.com/ceco/${val.productImage}`} />
                  )
                })
              }
            </div>
            <div 
              className="zhibo-btn"
              onClick={()=>{
                this.handleClick(liveInfo)
              }}
            >
              <div className="zhibo-btn-txt">{ZhiBoStatusObj[status.toString()].btnTxt}</div>
              <div className="zhibo-btn-icon"></div>
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

export default ZhiboFloor;